<template>
  <div>
    <div class="gz" v-for="(item, index) in list" :key="index">
      <div class="gz-user">
        <div class="gz-user-img">
          <van-image
            fit="cover"
            width="100%"
            height="100%"
            :src="item.avatar"
            alt=""
          />
        </div>
        <div class="gz-user-info">
          <div class="gz-user-name">{{ item.name }}</div>
          <div class="gz-time">{{ item.created_time }}</div>
        </div>

        <div class="is-gz" v-if="btnTitle">
          <div class="gz-btn">
            <span>编辑</span>
          </div>
        </div>

        <div
          class="is-gz"
          v-else-if="myinfo && myinfo.id == item.uid"
          @click="delMyCommunity(item, index)"
        >
          <div class="del-btn">
            <span>删除</span>
          </div>
        </div>

        <div class="is-gz" v-else @click="follow(item)">
          <div class="ygz-btn" v-if="item.isFollow == 1">
            <i class="iconfont icon-check"></i>
            <span>已关注</span>
          </div>
          <div class="gz-btn" v-else>
            <i class="iconfont icon-jia"></i>
            <span>关注</span>
          </div>
        </div>
      </div>

      <div class="gz-text">{{ item.title }}</div>

      <div class="gz-img" v-if="item.thumb">
        <div
          v-for="(img, i) in item.thumb"
          :key="i"
          @click="lookImg(item.thumb, i)"
        >
          <van-image fit="cover" width="100%" height="100%" :src="img" alt="" />
        </div>
      </div>
      <!-- <div class="gz-video">
              <video controls src="../../assets/2.mp4"></video>
            </div> -->

      <div class="three-l">
        <div @click="share">
          <i class="iconfont icon-zhuanfa"></i>
          <span>{{ item.share }}</span>
        </div>
        <div @click.stop="clickComment(item)">
          <i class="iconfont icon-pinglun"></i>
          <span>{{ item.comment }}</span>
        </div>
        <div @click="fabulous(item)">
          <i
            class="iconfont icon-zan"
            :style="item.isFabulous == 1 ? 'color:#4FD9D5' : ''"
          ></i>
          <span>{{ item.fabulous }}</span>
        </div>
      </div>
      
      <div class="comment" v-if="item.commentList && item.commentList.length">
        <ul>
          <li
            v-for="(com, i) in item.commentList"
            :key="i"
            @click="clickcommentlist(com)"
          >
            <p class="comment-list">
              <span class="comment-name">{{ com.name }}</span>
              <template v-if="com.pid">
                <span class="comment-connect">回复</span>
                <span class="comment-name">{{ com.pName }}</span>
              </template>
              <span class="comment-connect"  style="word-break:break-all;color:#666666">:{{ com.title }}</span>
              <!-- <span class="comment-name">{{ com.name }}</span>
                <template v-if="com.pid">
                  <span class="comment-connect">回复</span>
                  <span class="comment-name">{{ com.pName }}</span>
                </template>
                <span class="comment-connect">:</span>
              </span>
              <span style="flex: 1;word-break:break-all">{{ com.title }}</span> -->
            </p>
          </li>
        </ul>
        <div
          class="look-more"
          v-if="
            item.commentListAll &&
              item.commentListAll.length > 2 &&
              item.commentList.length <= 2
          "
          @click="lookMore(index)"
          style="text-align:center;margin-top:10px"
        >
          查看更多
        </div>
        <div
          class="look-more"
          v-if="
            item.commentListAll &&
              item.commentListAll.length > 2 &&
              item.commentList.length > 2
          "
          @click="lookMore1(index)"
          style="text-align:center;margin-top:10px"
        >
          收起
        </div>
      </div>
      <div class="comment empty" style="text-align: center;" v-else>
        暂无评论
      </div>
    </div>
    <div style="height:70px"></div>
    <!-- 评论 -->
    <div class="send-input" v-show="showInput">
      <div>
        <div class="text-box">
          <input
            ref="inp"
            type="text"
            v-model="sendText"
            :placeholder="inputPlaceholder"
          />
        </div>
        <div
          class="send"
          v-show="sendText"
          @mousedown.prevent
          @click.stop="communityComment"
        >
          发送
        </div>
      </div>
    </div>
    <shareComp
      :id="id"
      :type="1"
      v-show="shareMask"
      @closeShareMask="closeShareMask"
      :des="des"
      :shareImg="shareImg"
    ></shareComp>
    <shareBottomComp v-if="popShare == 1"></shareBottomComp>
  </div>
</template>

<script>
import { Dialog } from "vant";
import shareComp from "@/components/share.vue";

/**
@description:帖子
@createTime:2021-09-01
@create:wq
*/
import shareBottomComp from '@/components/shareBottomComp'
import { getQueryString ,shareJsSdk} from "@/utils/tool";
export default {
  name: "",
  props: ["btnTitle"],
  components: { shareComp ,shareBottomComp},
  data() {
    return {
      myinfo: JSON.parse(localStorage.getItem("user")),
      sendText: "",
      showInput: false,
      inputPlaceholder: "请输入",
      postsID: "",
      pid: "",
      pName: "",
      cflag: true,
      shareMask: false,
      id: "",
      list: [],
      des:'',
      popShare:0,
      shareImg:''
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  created() {
    this.id = this.$route.query.id;
    if (getQueryString("share")) {
      this.popShare = 1;
    }else{
      this.popShare = 0
    }
    this.communityOne();
  },
  methods: {
    communityOne() {
      this.api.communityOne({ id: this.id }).then((res) => {
        this.list = res.data.data;
        this.des = this.list[0].title;
        this.shareImg = this.list[0].thumb ? this.list[0].thumb[0] : '';
        let user = localStorage.getItem("user");
        let usercode = user ? user.account : "";
        shareJsSdk('postDetails','可以测社区',this.des,this.id,this.shareImg,usercode)
        
      });
    },
    lookImg(imgs, index) {
      this.imagePreview(imgs, index);
    },
    lookMore(index) {
      this.$emit("lookMore", index);
    },
    lookMore1(index) {
      this.$emit("lookMore1", index);
    },
    // 点赞
    fabulous(item) {
      this.api.fabulous({ id: item.id }).then(() => {
        if (item.isFabulous == 1) {
          item.isFabulous = 0;
          item.fabulous--;
        } else {
          item.isFabulous = 1;
          item.fabulous++;
        }
      });
    },
    //关注
    follow(item) {
      this.api.follow({ id: item.uid }).then(() => {
        if (item.isFollow == 1) {
          item.isFollow = 0;
          this.Toast.success("取消成功");
        } else {
          item.isFollow = 1;
          this.Toast.success("关注成功");
        }
      });
    },
    //删除
    delMyCommunity(item, index) {
      Dialog.confirm({
        // title: "标题",
        message: "确认删除么？",
      })
        .then(() => {
          // on confirm
          this.api.delMyCommunity({ id: item.id }).then(() => {
            this.list.splice(index, 1);
            this.Toast.success("删除成功");
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    clickComment(item) {
      this.postsID = item.id;
      this.pid = 0;
      this.pName = "";
      this.inputPlaceholder = "请输入";
      this.changeInput();
    },
    clickcommentlist(item) {
      if (
        localStorage.getItem("user") &&
        item.uid == JSON.parse(localStorage.getItem("user")).id
      )
        return;
      this.postsID = item.cid;
      this.pid = item.id;
      this.pName = item.name;
      this.inputPlaceholder = "回复" + item.name;
      this.cflag = true;
      this.changeInput();
    },
    changeInput() {
      this.showInput = true;
      this.$nextTick(() => {
        this.$refs.inp.focus();
        this.$refs.inp.onblur = () => {
          // setTimeout(() => {
          this.showInput = false;
          // }, 100);
        };
      });
    },
    //评论
    communityComment() {
      if (!this.cflag) return;

      this.cflag = false;
      this.api
        .communityComment({
          id: this.postsID,
          pid: this.pid,
          title: this.sendText,
        })
        .then(() => {
          // this.showInput = false;
          const tz = this.list.find((o) => o.id == this.postsID);
          const newobj = {
            title: this.sendText,
            name: JSON.parse(localStorage.getItem("user")).name,
            cid: this.postsID,
            pid: this.pid,
            pName: this.pName,
            uid: JSON.parse(localStorage.getItem("user")).id,
          };
          this.showInput = false;
          this.inputPlaceholder = "请输入";
          this.sendText = "";
          tz.commentList.push(newobj);
          this.cflag = true;
        });
    },
    share() {
      // this.$emit("openShare");
      this.shareMask = true;

    },
    closeShareMask() {
      this.shareMask = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.gz {
  // padding: 0.24rem 0.24rem 0;
  // border-bottom: 0.12rem solid #f1f1f1;
  .gz-user {
    display: flex;
    padding: 0.24rem 0.24rem 0;
    align-items: flex-end;
    .gz-user-img {
      width: 0.8rem;
      height: 0.8rem;
      border-radius: 50%;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 8px;
      img {
        width: 100%;
      }
    }
    .gz-user-info {
      flex: 1;
      .gz-user-name {
        font-size: 0.32rem;
        font-weight: bold;
        color: #4cd8d4;
      }
      .gz-time {
        font-size: 0.25rem;
        font-weight: 400;
        color: #999;
      }
    }
    .is-gz {
      .gz-btn {
        width: 1.3rem;
        height: 0.6rem;
        background: rgba(79, 217, 213, 0.1);
        border: 1px solid #4fd9d5;
        border-radius: 0.3rem;
        font-size: 0.26rem;
        font-weight: 400;
        color: #4fd9d5;
        display: flex;
        align-items: center;
        justify-content: center;
        i {
          margin-right: 3px;
        }
      }
      .ygz-btn {
        
        width: 1.54rem;
        height: 0.6rem;
        background: rgba(188, 188, 188, 0.1);
        border: 1px solid #cccccc;
        border-radius: 0.3rem;
        font-size: 0.26rem;
        font-weight: 400;
        color: #999999;
        display: flex;
        align-items: center;
        justify-content: center;
        i {
          margin-right: 3px;
        }
      }
      .del-btn {
        width: 1.3rem;
        height: 0.6rem;
        background: rgba(238, 10, 36, 0.1);
        border: 1px solid #ee0a24;
        border-radius: 0.3rem;
        font-size: 0.26rem;
        font-weight: 400;
        color: #ee0a24;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
  .gz-text {
    margin-top: 0.24rem;
    font-size: 0.3rem;
    padding: 0 0.24rem;
    font-weight: 400;
    color: #666666;
    white-space: pre-wrap;
  }
  .gz-img {
    padding: 0.24rem 0.24rem 0;
    margin-top: 0.16rem;
    display: flex;
    flex-wrap: wrap;
    > div {
      width: 2.3rem;
      height: 2.3rem;
      margin-right: 0.06rem;
      margin-bottom: 0.06rem;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 0.1rem;
      overflow: hidden;
      img {
        width: 100%;
      }
      &:nth-child(3n) {
        margin-right: 0;
      }
    }
  }
  .gz-video {
    margin-top: 0.16rem;
    max-width: 100%;
    border-radius: 0.1rem;
    overflow: hidden;
    video {
      width: 100%;
    }
  }
  .three-l {
    border-bottom: 10px solid #f1f1f1;
    display: flex;
    align-items: center;
    padding: 6px 0;
    margin-top: 0.24rem;
    border-top: 1px solid #f0f0f0;
    // padding: 0.24rem 0.24rem 0;
    > div {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 0.26rem;
      font-weight: 400;
      color: #999999;
      i {
        margin-right: 4px;
      }
    }
  }
}

.comment {
  
  width: 100%;
  // background: #f6f6f6;
  border-radius: 5px;
  padding: 6px 10px;
  box-sizing: border-box;
  // margin: 10px 0;
  font-size: 0.28rem;
  overflow: hidden;
  .comment-name {
    color: #72e0dd;
    // font-weight: 700;
  }
  li {
    margin: 4px 0;
  }
  .comment-connect {
    margin: 0 5px;
  }
}

.send-input {
  width: 100%;
  height: 50px;
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  background: #f2f2f2;
  z-index: 99;
  display: flex;
  align-items: center;
  justify-content: center;
  > div {
    width: 95%;
    height: 35px;

    display: flex;
    align-items: center;
    box-sizing: border-box;
  }
  .text-box {
    padding: 0 10px;
    flex: 1;
    height: 100%;
    border-radius: 20px;
    background: #ffffff;
    overflow: hidden;
    input {
      border: none;
      outline: none;
      width: 100%;
      height: 100%;
    }
  }
  .send {
    margin-left: 10px;
    background: #4fd9d5;
    font-size: 16px;
    height: 30px;
    color: #ffffff;
    border-radius: 5px;
    line-height: 30px;
    padding: 0 10px;
  }
}
.comment-list {
  margin-bottom: 0.25rem;
}
.empty{
  font-size: 0.3rem;
  margin-top: 0.2rem;
  font-weight: 400;
  color:#666;
}
</style>
